"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var DexfWebplannerService_1 = __importDefault(require("../../services/product/DexfWebplannerService"));
var ProductCache_1 = __importDefault(require("./ProductCache"));
var CacheStoreType_1 = __importDefault(require("../../enums/CacheStoreType"));
var ProductItemQueue_1 = __importDefault(require("./ProductItemQueue"));
var utilities_1 = require("@ikea-aoa/utilities");
var LocalizationService_1 = __importDefault(require("../localization/LocalizationService"));
var exceptions_1 = require("@ikea-aoa/exceptions");
/**
 * This class is used as a simple interface for product services.
 */
var ProductService = /** @class */ (function () {
    /**
     * Constructor.
     *
     * @param options Options.
     */
    function ProductService(options) {
        this.productCache = null;
        this.productItemQueue = null;
        this.localizationPrefixApplication = null;
        this.localizationEndpoints = null;
        this.localizationOverrides = null;
        this.locale = null;
        this.dexfApplicationId = null;
        this.cache = null;
        this.localizationPrefixApplication = options.localizationPrefixApplication;
        this.localizationEndpoints = options.localizationEndpoints;
        this.localizationOverrides = options.localizationOverrides;
        this.locale = options.locale;
        this.dexfApplicationId = options.dexfApplicationId || null;
        this.cache = options.cache || new utilities_1.GlobalCacheStore();
        var cacheStore = this.cache.getStore(CacheStoreType_1.default.product);
        this.productCache = new ProductCache_1.default(options.locale, this.cache);
        this.productItemQueue = cacheStore.get(options.locale + 'queue') || new ProductItemQueue_1.default();
        cacheStore.set(options.locale + 'queue', this.productItemQueue);
    }
    /**
     * Fetches and returns products.
     *
     * @param items Array of items.
     * @param [fields] Fields.
     * @returns Promise.
     */
    ProductService.prototype.getProducts = function (items, fields) {
        if (fields === void 0) { fields = null; }
        return __awaiter(this, void 0, void 0, function () {
            var cached, itemsAndCallbacks, service, products;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        cached = this.productCache.getProducts(items, fields);
                        if (cached.missing.length === 0) {
                            return [2 /*return*/, cached.products];
                        }
                        itemsAndCallbacks = { items: items, callbacks: [] };
                        if (!!fields) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.productItemQueue.retrieveItems(cached.missing)];
                    case 1:
                        itemsAndCallbacks = _a.sent();
                        _a.label = 2;
                    case 2:
                        if (!(itemsAndCallbacks.items.length > 0)) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.getService()];
                    case 3:
                        service = _a.sent();
                        return [4 /*yield*/, service.getProducts(itemsAndCallbacks.items, fields)];
                    case 4:
                        products = _a.sent();
                        this.productCache.addProducts(products, fields);
                        this.productItemQueue.releaseWaiting(itemsAndCallbacks.callbacks);
                        _a.label = 5;
                    case 5: return [2 /*return*/, this.productCache.getProducts(items, fields).products];
                }
            });
        });
    };
    /**
     * Returns an Array of fetched ShoppingProduct objects.
     *
     * @param shoppingItems Array of ShoppingItem.
     * @returns Array of ShoppingProduct objects.
     */
    ProductService.prototype.getShoppingProducts = function (shoppingItems) {
        return __awaiter(this, void 0, void 0, function () {
            var products, shoppingItemsMap, _i, shoppingItems_1, shoppingItem;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getProducts(shoppingItems)];
                    case 1:
                        products = _a.sent();
                        shoppingItemsMap = {};
                        for (_i = 0, shoppingItems_1 = shoppingItems; _i < shoppingItems_1.length; _i++) {
                            shoppingItem = shoppingItems_1[_i];
                            shoppingItemsMap[shoppingItem.type.toLowerCase() + shoppingItem.id] = shoppingItem;
                        }
                        return [2 /*return*/, products.map(function (product) {
                                if (!product.content) {
                                    return {
                                        product: product,
                                        quantity: shoppingItemsMap[product.itemId.toLowerCase()].quantity
                                    };
                                }
                                var itemType = product.content.itemType.toLowerCase();
                                var item = shoppingItemsMap[itemType + product.content.itemNoLocal] ||
                                    shoppingItemsMap[itemType + product.content.itemNoGlobal];
                                return {
                                    product: product,
                                    quantity: item.quantity
                                };
                            })];
                }
            });
        });
    };
    /**
     * Fetches and returns all products for a planner.
     *
     * @param [fields] Fields.
     * @returns Promise.
     */
    ProductService.prototype.getApplicationProducts = function (fields) {
        if (fields === void 0) { fields = null; }
        return __awaiter(this, void 0, void 0, function () {
            var service, products;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.dexfApplicationId) {
                            throw new exceptions_1.ServiceException('Failed to fetch application products. The configuration "dexfApplicationId" has not been defined. Send it in to the contructor of ProductService.');
                        }
                        return [4 /*yield*/, this.getService()];
                    case 1:
                        service = _a.sent();
                        return [4 /*yield*/, service.getApplicationProducts(this.dexfApplicationId, fields)];
                    case 2:
                        products = _a.sent();
                        this.productCache.addProducts(products, fields);
                        return [2 /*return*/, products];
                }
            });
        });
    };
    /**
     * Returns service.
     *
     * @returns Service.
     */
    ProductService.prototype.getService = function () {
        return __awaiter(this, void 0, void 0, function () {
            var localizationService, localizedInformation;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        localizationService = new LocalizationService_1.default({
                            localizationPrefixApplication: this.localizationPrefixApplication,
                            localizationEndpoints: this.localizationEndpoints,
                            localizationOverrides: this.localizationOverrides,
                            locale: this.locale,
                            cache: this.cache
                        });
                        return [4 /*yield*/, localizationService.getLocalizedInformation()];
                    case 1:
                        localizedInformation = _a.sent();
                        return [2 /*return*/, new DexfWebplannerService_1.default({
                                endpoint: localizedInformation.endpoints.dexfWebplannerService,
                                dexfApiKey: localizedInformation.localization.dexfApiKey
                            })];
                }
            });
        });
    };
    return ProductService;
}());
exports.default = ProductService;
//# sourceMappingURL=ProductService.js.map